import { api } from '../config/api';

export const userManagementService = {
  // Obtener todos los usuarios
  getAll: async () => {
    return await api.get('/users/');
  },

  // Obtener un usuario por ID
  getById: async (id) => {
    return await api.get(`/users/${id}/`);
  },

  // Crear un usuario
  create: async (userData) => {
    return await api.post('/users/', userData);
  },

  // Actualizar un usuario
  update: async (id, userData) => {
    return await api.put(`/users/${id}/`, userData);
  },

  // Eliminar un usuario (soft delete)
  delete: async (id) => {
    return await api.delete(`/users/${id}/`);
  },

  // Resetear contraseña de un usuario (solo sysadmin)
  resetPassword: async (id, newPassword = null) => {
    const data = {};
    if (newPassword && newPassword.trim()) {
      data.new_password = newPassword.trim();
    }
    // Si no hay contraseña, enviar objeto vacío para usar la por defecto
    return await api.post(`/users/${id}/reset-password/`, data);
  },

  // Cambiar contraseña de un usuario (solo sysadmin)
  changePassword: async (id, newPassword) => {
    return await api.post(`/users/${id}/change-password/`, { new_password: newPassword });
  }
};

